module.exports = __webpack_public_path__ + "img/sv104.30b165a0.svg";